import styled from "@emotion/styled";
import ICheck from "@images/p_check.png";
// import ICheck from "@images/icons/p_check.inline.svg";
export const OverViewTab = styled.div`
  h5 {
    font-size: 1.125rem;
    font-family: "Barlow", "sans-serif";
    font-weight: 700;
    margin-bottom: 1.5rem;
  }

  p {
    margin-bottom: 1.5rem;
  }
  ul {
    margin-left: 1.5rem;
  }
  li {
    margin-bottom: 1rem;
  }
  p {
    margin-bottom: 1rem;
  }

  p::before {
    background-image: url("@images/icons/p_check.svg");
  }
`;

// TODO: Need to change content
export const ProductFeatureHero = styled.div`
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  ul li,
  p {
    margin-bottom: 1rem;
    padding-left: 1rem;
    position: relative;
  }
  ul li::before,
  p::before {
    content: "";
    display: inline-block;
    background-image: url(${ICheck});
    margin-left: 0;
    padding-top: 10px;
    width: 1rem;
    height: 1rem;
    background-repeat: no-repeat;
    background-position: center center;
    margin-right: 1rem;
    position: absolute;
    left: -1em;
    top: 0;
  }
  ul li::marker {
    content: "";
    list-style-type: none;
    white-space: nowrap;
    margin-left: 0;
    width: 1rem;
    height: 1rem;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 1rem;
    margin-left: 1rem;
  }
`;

export const ProductAccessoryHero = styled.div`
  ul {
    li {
      margin-bottom: 1rem;
    }
    li::marker {
      content: "";
    }
  }
  p,
  h5 {
    margin-bottom: 1rem;
  }

  p::before {
    background-image: url("@images/icons/p_check.svg");
  }
`;

export const SpecificationHero = styled.div`
  p {
    margin-bottom: 1rem;
  }
`;

export const InfoTabHero = styled.div`
  .chakra-tabs [aria-selected="true"] [aria-label="indicator"] {
    display: block;
  }
`;
